import React from 'react';
import Tulips from '../Tulips';
import { SITE_CONTENT } from '../../data/siteContent';
import { Flower2 } from 'lucide-react';

export default function SobreMi() {
  const { title, bio } = SITE_CONTENT.sobreMi;
  return (
    <section className="w-full flex flex-col items-center">
      <div className="mb-6 md:mb-10">
        <Tulips />
      </div>

      <div className="relative w-full max-w-3xl mx-auto">
        <div className="absolute -top-2 -left-2 w-4 h-4 rounded-full bg-[#e8d36a]/60 blur-[1px]" />
        <div className="absolute -bottom-2 -right-2 w-3 h-3 rounded-full bg-[#cdb2e0]/70 blur-[1px]" />
        <div className="rounded-[28px] bg-[#fbeed7]/70 border border-[#ead6b4]/70 backdrop-blur-sm shadow-[0_14px_40px_-20px_rgba(120,80,60,0.25)] px-6 sm:px-8 md:px-14 py-10 md:py-14">
          <h2 className="text-center font-serif-display text-[1.75rem] md:text-[2rem] text-[#3f2e22] flex items-center justify-center gap-3">
            <Flower2 className="w-5 h-5 text-[#c28fb4]" strokeWidth={1.6} />
            {title}
            <Flower2 className="w-5 h-5 text-[#c28fb4]" strokeWidth={1.6} />
          </h2>

          <p className="mt-8 text-center leading-[1.95] text-[0.97rem] md:text-[1rem] text-[#5b4632] font-body">
            {bio}
          </p>
        </div>
      </div>

      <div className="mt-10 md:mt-14">
        <Tulips colors={['#f3dc78', '#efe0a4', '#e9c1d5', '#d7c4eb', '#e8d36a']} />
      </div>
    </section>
  );
}
